import { FC } from "react";
import { Text, TextProps } from "../../ui/RenderUIElement/Text";

/*
  This is crutch! without it three-mesh-ui will crush
  It has some problems with fonts propagation with components remounting
  So we just fontFamily to each Text block directly
*/
export const TwitterText: FC<TextProps> = (props) => <Text fontFamily="Roboto" fontTexture="Roboto" {...props} />;
